import './IndicatorsSearchForm.css';

import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Search } from '@mui/icons-material';
import B2BFormContainer from '../../b2b-common/B2BFormContainer';
import { generateClassName, generateSelectField, generateTextField, handleObjectFieldChange } from '../../b2b-common/helpers';
import { LoginContext } from '../../../App';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const IndicatorsSearchForm = ({ title,
    currentPage, setCurrentPage, refresh, setRefresh, isSearching, setIsSearching,
    searchFunction, setIndicatorsData, setPagesCount }) => {

    const { t } = useB2BTranslation('b2b-indicators');
    const { loginData } = useContext(LoginContext);
    const [error, setError] = useState(null);
    const [searchFields, setSearchFields] = useState({
        indicatorName: '',
        description: '',
        indicatorType: '',
    });

    const getIndicatorsData = useCallback(async () => {
        try {
            if (loginData && currentPage > 0 && refresh && !isSearching) {
                setIsSearching(true);
                const { accessToken } = loginData;
                const data = await searchFunction(currentPage - 1, 12, searchFields, accessToken);
                setIndicatorsData(data);
                setPagesCount(data.totalPages);
                setRefresh(false);
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setIsSearching(false);
        }
    }, [loginData, refresh, currentPage]);

    useEffect(() => {
        // console.log('IndicatorsSearchForm: useEffect: currentPage:', currentPage, 'refresh:', refresh);
        if (currentPage !== 0 || refresh) {
            getIndicatorsData();
        }
    }, [currentPage, refresh, getIndicatorsData]);

    // useEffect(() => {
    //     setRefresh(true);
    // }, [currentPage]);

    const onSearch = async () => {
        setCurrentPage(1);
        setRefresh(true);
    }

    const buttonsConfig = [
        {
            label: t('Search'),
            disabledText: t('Search'),
            onClick: onSearch,
            isLoading: isSearching,
            color: 'secondary',
            variant: 'contained',
            key: '1',
            icon: <Search />,
        },
    ];

    const indicatorTypes = [
        {
            value: '',
            label: t('All'),
            default: true,
        },
        {
            value: 'QUANTITATIVE',
            label: t('Quantitative'),
        },
        {
            value: 'QUALITATIVE',
            label: t('Qualitative'),
        },
        {
            value: 'QUANTITATIVE_DIMENSIONAL',
            label: t('Dimensional'),
        },
    ];

    return (
        <B2BFormContainer title={title ? title : t('Search form')} className={`${generateClassName("indicators-search-form", "")} b2b-search-form-01`} orientation="horizontal" showDivider={false} buttonsConfig={buttonsConfig}>
            {generateTextField(t('Indicator name'), searchFields.indicatorName, generateClassName("indicators-search-form", "-search-field"), false, (e) => handleObjectFieldChange('indicatorName', e.target.value, setSearchFields), { required: false })}
            {generateTextField(t('Description'), searchFields.description, generateClassName("indicators-search-form", "-search-field"), false, (e) => handleObjectFieldChange('description', e.target.value, setSearchFields), { required: false })}
            {generateSelectField(indicatorTypes,
                {
                    label: t('Indicator type'),
                    value: searchFields.indicatorType,
                    onChange: (e) => handleObjectFieldChange('indicatorType', e.target.value, setSearchFields),
                    className: generateClassName("indicators-search-form", "-search-select-field"),
                })}
        </B2BFormContainer>
    );
}

export default IndicatorsSearchForm;